import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/utils'

const badgeVariants = cva(
  'inline-flex items-center px-1.5 py-0.5 text-[9px] font-mono font-semibold uppercase tracking-[0.08em] border',
  {
    variants: {
      variant: {
        default: 'bg-[#00ff8820] text-[#00ff88] border-[#00ff88]',
        destructive: 'bg-[#ff444420] text-[#ff4444] border-[#ff4444]',
        warning: 'bg-[#ffaa0020] text-[#ffaa00] border-[#ffaa00]',
        secondary: 'bg-transparent text-[#888] border-[#333]',
        outline: 'border-[#333] text-[#666] bg-transparent',
        blue: 'bg-[#4488ff20] text-[#4488ff] border-[#4488ff]',
      },
    },
    defaultVariants: { variant: 'default' },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />
}

// eslint-disable-next-line react-refresh/only-export-components
export { Badge, badgeVariants }
